import React from 'react';

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    padding: '20px',
  },
  wrapper: {
    maxWidth: '900px',
    margin: '0 auto',
  },
  card: {
    background: 'white',
    borderRadius: '12px',
    padding: '24px',
    marginBottom: '24px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  },
  h1: { fontSize: '28px', fontWeight: 'bold', margin: 0, color: '#1f2937' },
  h2: { fontSize: '20px', fontWeight: '600', marginTop: '20px', color: '#111827' },
  p: { color: '#374151', lineHeight: 1.6 },
  li: { color: '#374151', marginBottom: '6px' },
  kbd: { padding: '2px 6px', background: '#f3f4f6', borderRadius: '4px', border: '1px solid #e5e7eb' },
};

const HelpPage = () => {
  return (
    <div style={styles.container}>
      <div style={styles.wrapper}>
        <div style={styles.card}>
          <h1 style={styles.h1}>Wyrm Help & About</h1>
          <p style={{ ...styles.p, marginTop: '8px' }}>
            Wyrm (Clinical Input Processing Health Entry Recorder) helps you transcribe clinical dictation.
            Choose a recording mode, record your speech, then copy the output into your notes system.
          </p>

          <h2 style={styles.h2}>Recording Modes</h2>
          <ul>
            <li style={styles.li}><strong>Realtime (Streaming):</strong> Transcribes while you speak. Best for live feedback.</li>
            <li style={styles.li}><strong>Batch (Complete File):</strong> Records first, then transcribes the whole clip at the end.</li>
          </ul>

          <h2 style={styles.h2}>Controls</h2>
          <ul>
            <li style={styles.li}><strong>Start/Stop Recording:</strong> Begins or ends recording in the selected mode.</li>
            <li style={styles.li}><strong>Timer:</strong> Shows remaining time; click to reset.</li>
            <li style={styles.li}><strong>Select Latest:</strong> Copies the most recent sentence.</li>
            <li style={styles.li}><strong>Select All:</strong> Copies the entire transcription.</li>
            <li style={styles.li}><strong>Copy:</strong> Copies the text to your clipboard.</li>
            <li style={styles.li}><strong>Clear:</strong> Empties the transcription output.</li>
          </ul>

          <h2 style={styles.h2}>Shortcuts</h2>
          <p style={styles.p}>
            <kbd style={styles.kbd}>Ctrl</kbd>+<kbd style={styles.kbd}>D</kbd> Start/Stop ·
            <span> </span>
            <kbd style={styles.kbd}>Ctrl</kbd>+<kbd style={styles.kbd}>K</kbd> Correct (coming soon) ·
            <span> </span>
            <kbd style={styles.kbd}>Ctrl</kbd>+<kbd style={styles.kbd}>C</kbd> Copy
          </p>

          <h2 style={styles.h2}>Tips</h2>
          <ul>
            <li style={styles.li}>Use a quiet environment and speak clearly for best results.</li>
            <li style={styles.li}>If batch transcription fails, try again or switch to realtime.</li>
            <li style={styles.li}>Use the Dictionary to add terms, names, and acronyms for better accuracy.</li>
          </ul>

          <h2 style={styles.h2}>About</h2>
          <p style={styles.p}>Version 1.0.0 · Wyrm is built for secure, accurate clinical dictation.</p>
        </div>
      </div>
    </div>
  );
};

export default HelpPage;

